import z from 'zod';
import {progressScoreSchema} from './progressScoreSchema';
import {progressStudySchema} from './progressStudySchema';

/**
 * Document shape as stored in Firestore: users/{uid}/progress/{examModuleId}.
 * id is the examModuleId (document id) when reading.
 */
export const progressWriteSchema = z.object({
  scores: z.array(progressScoreSchema).default([]),
  study: z.array(progressStudySchema).default([]),
  lastSessionId: z.string().optional(),
});

export interface ProgressWrite extends z.infer<typeof progressWriteSchema> {}
